var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgImprove = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "improve_svg__a",
  width: 20,
  height: 20,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h20v20H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#improve_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#3B5AAE",
  d: "M8.333 11.813 9.166 10l1.813-.833-1.813-.834-.833-1.812-.834 1.812-1.812.834L7.499 10zm0 4.02L6.249 11.25 1.666 9.167l4.583-2.084L8.333 2.5l2.083 4.583 4.583 2.084-4.583 2.083zm6.666 1.667-1.041-2.292-2.292-1.041 2.292-1.042 1.041-2.292 1.042 2.292 2.292 1.042-2.292 1.041z"
}))));
export { SvgImprove as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPG1hc2sgaWQ9Im1hc2swXzYxMTUxXzIwNDk0IiBzdHlsZT0ibWFzay10eXBlOmFscGhhIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4PSIwIiB5PSIwIiB3aWR0aD0iMjAiIGhlaWdodD0iMjAiPgo8cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIGZpbGw9IiNEOUQ5RDkiLz4KPC9tYXNrPgo8ZyBtYXNrPSJ1cmwoI21hc2swXzYxMTUxXzIwNDk0KSI+CjxwYXRoIGQ9Ik04LjMzMjY4IDExLjgxMjVMOS4xNjYwMiAxMEwxMC45Nzg1IDkuMTY2NjdMOS4xNjYwMiA4LjMzMzMzTDguMzMyNjggNi41MjA4M0w3LjQ5OTM1IDguMzMzMzNMNS42ODY4NSA5LjE2NjY3TDcuNDk5MzUgMTBMOC4zMzI2OCAxMS44MTI1Wk04LjMzMjY4IDE1LjgzMzNMNi4yNDkzNSAxMS4yNUwxLjY2NjAyIDkuMTY2NjdMNi4yNDkzNSA3LjA4MzMzTDguMzMyNjggMi41TDEwLjQxNiA3LjA4MzMzTDE0Ljk5OTMgOS4xNjY2N0wxMC40MTYgMTEuMjVMOC4zMzI2OCAxNS44MzMzWk0xNC45OTkzIDE3LjVMMTMuOTU3NyAxNS4yMDgzTDExLjY2NiAxNC4xNjY3TDEzLjk1NzcgMTMuMTI1TDE0Ljk5OTMgMTAuODMzM0wxNi4wNDEgMTMuMTI1TDE4LjMzMjcgMTQuMTY2N0wxNi4wNDEgMTUuMjA4M0wxNC45OTkzIDE3LjVaIiBmaWxsPSIjM0I1QUFFIi8+CjwvZz4KPC9zdmc+Cg==";